export function onClickAll(cssPath, cb) {
  const $elements = document.querySelectorAll(cssPath);
  Array.from($elements).forEach(($element) => {
    $element.addEventListener('click', cb);
    $element.addEventListener('keydown', (event) => {
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        cb(event);
      }
    });
  });
}

export function unsubscribeOnClickAll(cssPath, cb) {
  const $elements = document.querySelectorAll(cssPath);
  Array.from($elements).forEach(($element) => {
    $element.removeEventListener('click', cb);
  });
}

const subscribersOnLongTouch = {};

export function onLongTouch(element, callback, timeout = 500) {
  let timeoutId;
  let blockPreventDefault = false;

  const obj = {
    touchstart(e) {
      const copyCurrentTarget = e.currentTarget; // NOTE: Need not lose currentTarget
      timeoutId = setTimeout(() => {
        e.preventDefault();
        e.stopPropagation();
        timeoutId = null;
        Object.defineProperty(e, 'currentTarget', { value: copyCurrentTarget }); // overwrite currentTarget
        blockPreventDefault = true;
        callback(e);
      }, timeout);
    },
    contextmenu(e) {
      e.preventDefault();
    },
    touchend(e) {
      if (blockPreventDefault) {
        e.preventDefault();
        blockPreventDefault = false;
      }
      if (timeoutId) clearTimeout(timeoutId);
    },
    touchmove() {
      if (timeoutId) clearTimeout(timeoutId);
    },
  };

  subscribersOnLongTouch[callback] = obj;

  element.addEventListener('touchstart', obj.touchstart);

  element.addEventListener('contextmenu', obj.contextmenu);

  element.addEventListener('touchend', obj.touchend);

  element.addEventListener('touchmove', obj.touchmove);
}

export function unsubscribeOnLongTouch(element, cb) {
  const obj = subscribersOnLongTouch[cb];

  if (obj) {
    element.removeEventListener('touchstart', obj.touchstart);

    element.removeEventListener('contextmenu', obj.contextmenu);

    element.removeEventListener('touchend', obj.touchend);

    element.removeEventListener('touchmove', obj.touchmove);
  }
}

export function onLongTouchAll(cssPath, cb) {
  const $elements = document.querySelectorAll(cssPath);
  Array.from($elements).forEach(($element) => {
    onLongTouch($element, cb);
  });
}

export function unsubscribeOnLongTouchAll(cssPath, cb) {
  const $elements = document.querySelectorAll(cssPath);
  Array.from($elements).forEach(($element) => {
    unsubscribeOnLongTouch($element, cb);
  });
}
